"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Checkbox = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _excluded = ["className", "label", "large", "checked"],
    _excluded2 = ["label", "maxWidth", "justifyContent"];

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8;

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var HiddenCheckbox = _styledComponents.default.input.attrs({
  type: 'checkbox'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    border: 0;\n    clip: rect(0 0 0 0);\n    clip-path: inset(50%);\n    height: 1px;\n    margin: -1px;\n    overflow: hidden;\n    padding: 0;\n    position: absolute;\n    white-space: nowrap;\n    width: 1px;\n"])));

var CheckboxContainer = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: inline-block;\n  vertical-align: middle;\n"])));

var Icon = _styledComponents.default.svg(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    fill: none;\n    display: flex;\n    stroke: ", ";\n    stroke-width: 2px;\n    max-height: 24px;\n"])), function (props) {
  return props.theme.colors.main;
});

var largeCheckBox = (0, _styledComponents.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    width: 40px;\n    height: 26px;\n"])));
var smallCheckBox = (0, _styledComponents.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    width: 18px;\n    height: 18px;\n    margin: 16px;\n"])));

var StyledCheckbox = _styledComponents.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n    display: inline-block;\n    ", ";\n    background: ", ";\n    border: ", ";\n    border-radius: 4px;\n    transition: all 150ms;\n    cursor: pointer;\n    box-shadow: ", "\n    ", ":focus + & {\n      box-shadow: ", ";\n    };\n    ", " {\n      visibility: ", "\n    };\n"])), function (props) {
  return props.large ? largeCheckBox : smallCheckBox;
}, function (props) {
  return props.checked ? props.theme.colors.grey700 : props.theme.colors.white;
}, function (props) {
  return "2px solid ".concat(props.theme.colors.grey300);
}, function (props) {
  return props.checked && "inset 0 0 6px ".concat(props.theme.colors.main400);
}, HiddenCheckbox, function () {
  return "0 0 0 3px ".concat(function (props) {
    return props.theme.colors.grey700;
  });
}, Icon, function (props) {
  return props.checked ? 'visible' : 'hidden';
});

var StyledLabel = _styledComponents.default.label(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n    font-size: 14px;\n    font-weight: 600;\n"])));

var CheckBoxDiv = _styledComponents.default.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n    display: flex;\n    justify-content: ", ";\n    max-width: ", ";\n    align-items: center;\n"])), function (props) {
  return props.justifyContent || 'flex-start';
}, function (props) {
  return props.maxWidth;
});

var CheckBoxPure = function CheckBoxPure(_ref) {
  var className = _ref.className,
      label = _ref.label,
      large = _ref.large,
      checked = _ref.checked,
      props = _objectWithoutProperties(_ref, _excluded);

  return _react.default.createElement(CheckboxContainer, {
    className: className
  }, _react.default.createElement(HiddenCheckbox, _extends({
    checked: checked
  }, props)), _react.default.createElement(StyledCheckbox, {
    large: large,
    checked: checked
  }, _react.default.createElement(Icon, {
    viewBox: "0 0 24 24"
  }, _react.default.createElement("polyline", {
    points: "20 6 9 17 4 12"
  }))));
};

var Checkbox = function Checkbox(_ref2) {
  var label = _ref2.label,
      maxWidth = _ref2.maxWidth,
      justifyContent = _ref2.justifyContent,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return label ? _react.default.createElement(CheckBoxDiv, {
    maxWidth: maxWidth,
    justifyContent: justifyContent
  }, _react.default.createElement(CheckBoxPure, _extends({
    htmlFor: label
  }, props)), _react.default.createElement(StyledLabel, {
    htmlFor: label
  }, label)) : _react.default.createElement(CheckBoxPure, _extends({
    htmlFor: label
  }, props));
};

exports.Checkbox = Checkbox;